<template>
    <nav class="d-md-block bg-light sidebar d-none d-lg-table-cell">
        <div class="sidebar-sticky" style="border: 1px solid gray; border-radius: 5px;margin-top:10px;">
            <adminMenu></adminMenu>
        </div>
    </nav>
</template>

<script>
    import adminMenu from '@/components/admin/AdminMenu.vue'
    export default {
        name: 'adminSidenav',
        components: {
            adminMenu
        }
    }
</script>
<style>
</style>